const RELOAD_GUARD_KEY = 'qpoint:stale-bundle-reload'
const RELOAD_COOLDOWN_MS = 30_000

const STALE_BUNDLE_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk \d+ failed/i,
  /ChunkLoadError/i,
  /Unable to preload CSS/i,
]

export function isStaleBundleError(error: unknown): boolean {
  if (!error) return false

  if (error instanceof Error && error.name === 'ChunkLoadError') return true

  const message =
    error instanceof Error
      ? `${error.name}: ${error.message}`
      : typeof error === 'string'
        ? error
        : ''

  if (!message) return false

  return STALE_BUNDLE_PATTERNS.some((pattern) => pattern.test(message))
}

export function isStaleBundleRecoverable(error: unknown): boolean {
  if (!isStaleBundleError(error)) return false
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return false
  }
  return true
}

export function reloadForStaleBundle(): boolean {
  if (typeof window === 'undefined') return false
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return false
  }

  try {
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? 0)
    if (Number.isFinite(last) && Date.now() - last < RELOAD_COOLDOWN_MS) {
      return false
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  } catch {
    return false
  }

  window.location.reload()
  return true
}

export function installStaleBundleHandler(): void {
  if (typeof window === 'undefined') return

  window.addEventListener('vite:preloadError', ((event: Event) => {
    if (reloadForStaleBundle()) event.preventDefault()
  }) as EventListener)

  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleBundleRecoverable(event.reason)) {
      if (reloadForStaleBundle()) event.preventDefault()
    }
  })
}
